import { BreakpointProps } from '@ux/responsive';

import { VisibleItems } from './constants';
import { SalesboardProductType } from './Salesboard';

export const getFeaturesLengths = (products: Array<SalesboardProductType>) => {
  const featureLengthArray = [] as Array<number>;
  products.forEach((product) => {
    featureLengthArray.push(product.features?.length ?? 0);
  });
  return featureLengthArray;
};

export const getMaxFeatureLimit = (products: Array<SalesboardProductType>) => {
  const featureLengthArray = getFeaturesLengths(products);
  return Math.max(...featureLengthArray);
};

export const getVisibleItems = (breakpoints: BreakpointProps) => {
  const { isMinSm, isMinMd, isMinLg, isMinXl } = breakpoints;
  if (isMinXl) {
    return VisibleItems.XL;
  }
  if (isMinLg) {
    return VisibleItems.LG;
  }
  if (isMinMd) {
    return VisibleItems.MD;
  }
  if (isMinSm) {
    return VisibleItems.SM;
  }
  return VisibleItems.XS;
};
